import { useCallback, useLayoutEffect, useState } from "react";

type UseElementWidthOptions = {
  enabled?: boolean;
};

export function useElementWidth<T extends HTMLElement = HTMLDivElement>(
  options: UseElementWidthOptions = {},
) {
  const enabled = options.enabled ?? true;
  const [element, setElement] = useState<T | null>(null);
  const [width, setWidth] = useState(0);

  const ref = useCallback((node: T | null) => {
    setElement(node);
  }, []);

  useLayoutEffect(() => {
    if (!enabled) {
      setWidth(0);
      return;
    }

    if (!element) {
      return;
    }

    const measure = () => {
      setWidth(element.getBoundingClientRect().width);
    };

    measure();

    const observer = new ResizeObserver(measure);
    observer.observe(element);

    const parent = element.parentElement;
    if (parent) {
      observer.observe(parent);
    }

    return () => observer.disconnect();
  }, [enabled, element]);

  return { ref, width, element };
}
